module.exports = __webpack_public_path__ + "static/media/地震發生前有沒有和家人討論避難方法 vs 地震後曾去哪些地方暫住.fb996bba.png";